import { Store } from '@mui/icons-material';
import { VenueManagementManager } from '../modules/venue-management/VenueManagementManager';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const VenueManagement: RouteType = {
  exact: true,
  path: routePaths.venueManagement,
  title: 'Venue Management',
  icon: Store,
  component: () => <VenueManagementManager />,
  permission: 'canManageVenues',
};

export default VenueManagement;
